// extracted by mini-css-extract-plugin
export default {"container":"_29pZojfA","tick":"_3IsIhfAh"};